export default (state) => ({
	get hasResults() {
		return state.results !== null;
	},
});
